export default {
  locale: "en",
  messages: {
    vi: {
      teible: {
        showing: "Hiển thị",
        total: "trên tổng số {count} bản ghi",
        last: "bản ghi cuối cùng",
        empty: "Không có dữ liệu",
        filter: "Lọc các bản ghi",
      },
      route: {
        overview: "Tổng Quan",
        threat: "Mối Đe Dọa",
        agent: "Máy Trạm",
        management: "Quản Trị",
        policy: "Chính Sách",
        report: "Báo Cáo",
        alert: "Cảnh Báo",
        schedule: "Đặt Lịch",
        config: "Cài Đặt",
        info: "Thông tin",
        intergration: "Tích hợp",
        group: "Nhóm Máy Trạm",
        license: "Bản Quyền",
        server: "Máy chủ",
        user: "Người Dùng",
        update: "Cập Nhật",
        search: "Tìm kiếm...",
        notFound: "KHÔNG TÌM THẤY TRANG"
      },
      global: {
        detail: "Chi Tiết",
        action: "Hành Động",
        edit: "Chỉnh Sửa",
        update: "Cập Nhật",
        delete: "Xóa",
        submit: "Xác Nhận",
        close: "Đóng",
        add: "Thêm",
        send: "Gửi",
        cancel: "Hủy",
        download: "Tải Về",
        all: "Tất cả",
        quickView: "Xem Nhanh",
        confirmDelete: "Bạn có chắc rằng bạn muốn xóa không?",
        next: "Tiếp theo",
        upload: "Tải lên",
        uploadAgain: "Tải lại",
        complete: "Hoàn thành",
        active: "Kích hoạt",
        check: "Kiểm tra",
        checkAgain: "Kiểm tra lại",
        back: "Trở lại",
        finish: "Kết thúc",
        downloadDown: "Tải xuống",
        reset: "Làm lại",
      },
      components: {
        login: {
          downloadCyEDR: "Tải về CyEDR",
          downloadCyES: "Tải về  CyRadar Endpoint Security",
        },
        overview: {
          protectedUsers: "Máy Trạm Được Bảo Vệ",
          detectedThreats: "Mối Nguy Hại Được Phát Hiện Và Xử Lý",
          highPriorityThreats: "Mối Đe Dọa Cao Đã Xử Lý",
          criticalThreats: "Mối Đe Dọa Nghiêm Trọng Đã Xử Lý",
          recentThreatEvents: "Mối Đe Dọa Gần Đây",
          topInfectedClients: "Máy Trạm Bị Nhiễm Nhiều Nhất",
          topInfectedGroups: "Nhóm Máy Trạm Bị Nhiễm Nhiều Nhất",
          category: "Phân Loại",
          clients: "Máy Trạm",
          groups: "Nhóm",
          total: "Tất cả",
          systemDiagram: "Sơ đồ hệ thống",
          totalGroup: "Tất cả các nhóm",
        },
        threats: {
          lowPriorityThreats: "Mối Đe Dọa Thấp Đã Xử Lý",
          mediumPriorityThreats: "Mối Đe Dọa Trung Bình Đã Xử Lý",
          highPriorityThreats: "Mối Đe Dọa Cao Đã Xử Lý",
          criticalThreats: "Mối Đe Dọa Nghiêm Trọng Đã Xử Lý",
          threatEvents: "Mối Đe Dọa",
          group: "Nhóm",
          processName: "Tên Tiến Trình",
          priority: "Mức Độ",
          category: "Phân Loại",
          malwareName: "Mã Độc",
          time: "Thời Gian",
          user: "Người Dùng",
          computerName: "Tên Máy",
          action: "Hành Động",
          sample: "Mẫu",
          activityDetail: "Thông Tin Chi Tiết",
          processTree: "Cây Tiến Trình",
          processInfo: "Thông tin Tiến Trình",
          name: "Tên",
          path: "Đường Dẫn",
          pid: "PID",
          parentPID: "PPID",
        },
        agents: {
          agents: "Máy Trạm",
          agentDetail: "Thông Tin Máy Trạm",
          group: "Nhóm",
          command: "Lệnh",
          commandType: "Loại Lệnh",
          path: "Đường Dẫn",
          pendingCommands: "Lệnh Đang Chờ",
          payload: "Gói Tin",
          time: "Thời Gian",
          status: "Trạng Thái",
          computerName: "Tên máy",
          removed: "Đã Gỡ Bỏ",
          ip: "IP Nội bộ",
          operatingSystem: "Hệ điều hành",
          agentVersion: "Phiên Bản",
          vulnerabilities: "Lỗ Hổng",
          installTime: "Thời Gian Cài Đặt",
          lastConnection: "Kêt Nối Lần Cuối",
          localIP: "IP Nội Bộ",
          action: "Hành Động",
          agentIP: "IP Kết nối",
          mac: "Mac",
          macNetwork: "Mac Network",
          lastUpdate: "Cập Nhật Window",
          userName: "Tên Tài Khoản",
          enableFirewall: "Kích Hoạt Tường Lửa",
          autoProtect: "Bảo Vệ Tự Động",
          message: "Tin Nhắn",
          contact: "Liên Hệ",
          active: "Hoạt Động",
          disabled: "Ngừng Kết Nối",
          disabledDesc:
            "Hiển thị danh sách máy trạm không có kết nối đến máy chủ trong vòng {days} ngày.",
          agentSetting: "Cài Đặt Máy Trạm",
          activeTimeout: "Thời Gian Chờ",
          days: "Ngày",
          timeoutDesc:
            "Máy trạm không có kết nối đến server trong khoảng thời gian này sẽ được chuyển qua phần ngừng kết nối.",
          timeoutEnableDesc: "Cài đặt thời gian chờ để sử dụng tính năng này.",
          timeoutDisableDesc: "Để tắt tính năng này, đặt thời gian chờ về 0.",
          securityStatus: "Hiện trạng an ninh",
          childGroups: "Nhóm con",
          threats: "Mối đe doạ",
          copyrights: "Bản quyền",
          version: "Phiên bản",
          threatCount: "Mối đe doạ",
          description: "Mô tả",
          viewInformation: "Xem thông tin",
          delete: "Xoá",
          update: "Cập nhật",
          Command: "Command",
          threat: "Mối đe doạ",
          license: "Bản quyền",
          serverInfor: "Thông tin server",
          commandAllAgents: "Lệnh tất cả máy trạm",
          commandGroupAgents: "Lệnh nhóm máy trạm",
          currentLicense: "Giấy phép hiện tại",
          destLicense: "Giấy phép mới"
        },
        policies: {
          add: "Thêm",
          policies: "Chính Sách",
          whitelist: "Cho Phép",
          blacklist: "Ngăn Chặn",
          scheduleScan: "Lịch Quét",
          restriction: "Hạn Chế Gỡ Bỏ",
          blacklistHelp:
            "Ngăn chặn máy trạm thực hiện kết nối đến các địa chỉ cụ thể",
          restrictionHelp:
            "Giới hạn người dùng khỏi 1 vài chức năng (vd. gỡ cài đặt).<br>Sử dụng mật khẩu được cung cấp bởi người quản trị để mở khóa.",
          unknownPC: "Unknown PC",
          name: "Tên",
          type: "Loại",
          computerName: "Tên Máy Trạm",
          audience: "Đối Tượng",
          action: "Hành Động",
          description: "Mô Tả",
          policyType: "Loại Chính Sách",
          groups: "Nhóm",
          agents: "Máy Trạm",
          general: "Chung",
          specific: "Cụ Thể",
          everyone: "Tất Cả",
          accessControlList: "Danh Sách Điều Khiển",
          ip: "IP",
          port: "Cổng",
          password: "Mật Khẩu",
          newPolicy: "Thêm Chính Sách",
          updatePolicy: "Cập Nhật Chính Sách",
          date: "Ngày quét",
          time: "Giờ quét",
          updateAgent: "Cập Nhật Máy Trạm",
          auto: "Tự động",
          manual: "Thủ công",
          schedule: "Đặt lịch",
          updateType: "Loại cập nhật",
          updateDatabase: "Cập Nhật Dữ Liệu",
          scheduleUpdate: "Lịch Cập nhật",
          once: "Một lần",
          daily: "Hàng ngày",
          weekly: "Hàng tuần",
          monthly: "Hàng tháng",
          interval: "Khoảng thời gian lặp",
          updatedAt: "Cập Nhật Cuối",
        },
        report: {
          reportExport: "Xuất Báo Cáo",
          group: "Nhóm",
          timeRange: "Khoảng Thời Gian",
          reportType: "Loại Báo Cáo",
          users: "Người Dùng",
          maliciousHosts: "Địa Chỉ Độc Hại",
          priorities: "Mức độ",
          categories: "Phân Loại",
          preview: "Xem Trước",
          download: "Tải Về",
          confirmation: "Xác Nhận",
          organizationID: "ID Tổ Chức",
          organizationName: "Tên Tổ Chức",
          organizationAddress: "Địa Chỉ Tổ Chức",
          email: "Email",
          telephone: "Điện Thoại",
          fax: "Fax",
          website: "Website",
          reportEndpoint: "Địa Chỉ Gửi Báo Cáo",
          confirmSubmit: "Xác Nhận & Gửi",
          pdfReport: "Báo Cáo Dạng PDF",
          noSupportPDF:
            "Trình duyệt không hỗ  trợ hiển thị PDF. Mời tải file PDF về để xem",
          downloadPDF: "Tải về PDF",
          xmlReport: "Báo Cáo Dạng XML",
          copyToClipboard: "Sao Chép",
          schedulesReport: "Đặt Lịch Báo Cáo",
          waiting: "Đang Chờ",
          failed: "Lỗi",
          done: "Xong",
          newScheduleTask: "Đặt Lịch Mới",
          updateMailReportTask: "Cập Nhật Tác Vụ: Định Kỳ Gửi Báo Cáo Qua Mail",
          updateXMLReportTask: "Cập Nhật Tác Vụ: Định Kỳ Gửi Báo Cáo XML",
          task: "Tác Vụ",
          status: "Trạng Thái",
          nextExecutation: "Lần Chạy Tới",
          repeating: "Lặp Lại",
          endding: "Thời Gian Kết Thúc",
          action: "Hành Động",
        },
        schedule: {
          schedules: "Đặt Lịch",
          waiting: "Đang Chờ",
          failed: "Lỗi",
          done: "Xong",
          newScheduleTask: "Đặt Lịch Mới",
          updateMailReportTask: "Cập Nhật Tác Vụ: Định Kỳ Gửi Báo Cáo Qua Mail",
          updateThreatNotifyTask: "Cập Nhật Tác Vụ: Cảnh Báo Tức Thì",
          updateXMLReportTask: "Cập Nhật Tác Vụ: Định Kỳ Gửi Báo Cáo XML",
          task: "Tác Vụ",
          status: "Trạng Thái",
          nextExecutation: "Lần Chạy Tới",
          repeating: "Lặp Lại",
          endding: "Thời Gian Kết Thúc",
          action: "Hành Động",
        },
        configuration: {
          organizationInfo: "Thông Tin Đơn Vị",
          agentsGroup: "Nhóm Máy Trạm",
          license: "Bản Quyền",
          dashboardUser: "Người Dùng Quản Trị",
          offlineUpdate: "Cập Nhật Ngoại Tuyến",
        },
        configurationInfo: {
          info: "Thông tin",
          group: "Nhóm",
          organizationInfo: "Thông Tin Tổ Chức",
          endpoint: "Địa Chỉ Nhận",
          organizationID: "ID Tổ Chức",
          organizationName: "Tên Tổ Chức",
          organizationAddress: "Địa Chỉ Tổ Chức",
          email: "Email",
          telephone: "Điện Thoại",
          fax: "Fax",
          website: "Website",
          reportEndpoint: "Địa Chỉ Gửi Báo Cáo",
        },
        configurationGroup: {
          groups: "Nhóm Máy Trạm",
          name: "Tên",
          groupKey: "Mã Nhóm",
          licenseKey: "Mã Bản Quyền",
          createLicense: "Tạo mã bản quyền mới cho nhóm",
          netmask: "Mặt Nạ Mạng",
          subnets: "Mạng Con",
          agents: "Máy Trạm",
          description: "Mô Tả",
          groupName: "Tên Nhóm",
          childGroups: "Nhóm Con",
          count: "Số Lượng",
          agentCount: "Số Lượng Máy",
          action: "Hành Động",
          createNewGroup: "Thêm Nhóm Mới",
          editGroup: "Cập Nhật Thông Tin Nhóm",
          serial: "Số thứ tự",
          parentGroup: "Nhóm cha",
          theadCount: "Số mối đe doạ",
          groupChildCount: "số nhóm con",
          licenseCount: "Mã bản quyền",
          update: "Cập nhật",
          delete: "Xoá",
          command: "Command",
          viewInformation: "Xem thông tin",
        },
        configurationLicense: {
          licenses: "Bản Quyền",
          random: "Ngẫu Nhiên",
          licenseKey: "Mã Bản Quyền",
          agentGroups: "Nhóm Máy Trạm",
          limit: "Giới Hạn",
          countLimit: "Số Lượng/Giới Hạn",
          limited: "Có Giới Hạn",
          unlimited: "Không Giới Hạn",
          agents: "Máy Trạm",
        },
        user: {
          dashboardUsers: "Người Dùng",
          userName: "Tên Tài Khoản",
          name: "Tên",
          type: "Loại",
          group: "Nhóm",
          oldPassword: "Mật Khẩu Cũ",
          password: "Mật Khẩu",
          confirmPassword: "Xác Nhận Mật Khẩu",
          action: "Hành Động",
          createNewUser: "Thêm Người dùng mới",
          updateUser: "Cập Nhật Thông Tin Người Dùng",
        },
        configurationUpdate: {
          viewRepo: "Xem kho lưu trữ",
          agent: "Phần Mềm",
          database: "Cơ Sở Dữ Liệu",
          offlineUpdate: "Cập Nhật Ngoại Tuyến",
          agentUpdateFile: "Cập Nhật Phần Mềm",
          dashboardUpdateFile: "Cập Nhật Cơ Sở Dữ Liệu",
          chooseAFile: "Lựa chọn file...",
          noFileChosen: "Chưa có file được chọn",
          initializing: "Đang khởi tạo",
          version: "Phiên bản",
          tag: "Loại sản phẩm",
          os: "Hệ điều hành",
          repositories: "Kho lưu trữ",
          serial: "STT",
          name: "Tên",
          createdAt: "Thời gian tạo",
          creator: "Người tạo",
          tags: "Loại sản phẩm",
          fileNumber: "Số File",
          status: "Tình trạng",
          type: "Loại",
          description: "Mô tả",
          updatedAt: "Cập nhật lần cuối",
          active: "Đã kích hoạt",
          inactive: "Không kích hoạt",
          invalidFormat: "Định dạng không hợp lệ",
          invalidName: "Tên sai định dạng",
          update: "Cập nhật",
          enable: "Kích hoạt",
          disable: "Huỷ kích hoạt",
          setDefault: "Đặt làm mặc định",
          default: "Mặc định",
          updateTag: "Cập nhật sản phẩm",
          createTag: "Tạo sản phẩm mới",
          updateOS: "Cập nhật hệ điều hành",
          createOS: "Tạo mới hệ điều hành",
          fileName: "Tên file",
          size: "Dung lượng",
          error: "Lỗi",
          ready: "Sẵn Sàng",
          viewInfor: "Xem thông tin",
          deleteFile: "Xoá tệp tin",
          checkMD5: "Kiểm tra MD5",
          inforFileUpdate: "Thông tin tệp cập nhật",
          database: "Database",
          baseEngine: "BsEngine",
          advanceEngine: "AvEngine",
          installer: "Installer",
          createRepo: "Tạo mới repositories",
          confirmDeleteFile: "Xác nhận xoá tệp tin",
          warning: "Chú ý! Hành động này không thể hoàn tác",
          uploadFile: "Tải lên file",
          downloadFile: "Tải xuống file",
          canceled: "Đã huỷ",
          cancelVersion: "Huỷ phiên bản",
          createVersion: "Tạo mới phiên bản mới",
          updateVersion: "Cập nhật version",
          basic: "Cơ bản",
          currentVersion: "Phiên bản hiện tại",
          supportedOSList: "Danh sách hệ điều hành hỗ trợ",
          attachFile: "Đính kèm file",
          cannotBeLeftBlank: "Trường này không được để trống",
          invalidFile: "Định dạng không được hỗ trợ",
          versionInfor: "Thông tin version",
          confirmDeactivate: "Xác nhận huỷ kích hoạt",
          confirmSetDefault: "Xác nhận đặt làm mặc định",
          tagName: "Tên thẻ",
          tagWarning:
            "Chú ý! Hành động này có thể ảnh hưởng đến cập nhật của các agent",
          noVersion: "Chưa có phiên bản nào được tạo",
          fileUploadError: "Tệp tin upload lỗi",
          enterName: "Nhập tên",
          enabled: "Đã kích hoạt",
          disabled: "Không kích hoạt",
          uploading: "Đang upload",
          createOfflineFile: "Tạo bản offline",
          confirmCreateVersionOffline: "Xác nhận tạo file version offline",
          createVersionOfflineWarning:
            "Bạn có chắc chắn muốn tạo file version này không?",
          createNew: "Tạo mới",
          uploadFileOffline: "Tải lên tệp offline",
          chooseFile: "Chọn file...",
          wrongFileType: "Định dạng file không phù hợp. Vui lòng tải file .zip",
          uploadFailed: "Tải file thất bại",
          uploadSuccessful:
            "Tải file thành công.Vui lòng đợi trong giây lát để hệ thống thực hiện thay đổi.",
          product: "Sản phẩm",
          deleteOSConfirm: "Xác nhận xoá OS",
          chooseTags: "Chọn products",
          versionValidLength: "Phiên bản phải có chiều dài từ 3 đến 256 kí tự",
          versionValidFormat:
            "Phiên bản không bao gồm dấu cách và chỉ có thể bao gồm các kí tự có kiểu chữ, số nguyên, các dấu . hoặc _",
          versionValidDuplication: "Phiên bản này đã tồn tại",
          fileValidFormat: "Định dạng không được hỗ trợ",
          uploadError: "Tệp tin tải lên bị lỗi",
          nameValidLength: "Tên phải có chiều dài từ 3 đến 256 kí tự",
          nameValidFormat:
            "Tên không chứa dấu cách và chỉ bao gồm kí tự chữ, số nguyên, dấu ., - hoặc _.",
          fileUploadOfflineValidFormat:
            "Định dạng file không phù hợp. Vui lòng tải file zip.",
          fileUploadOfflineSuccess:
            "Tải tập tin thành công. Vui lòng đợi trong giây lát để hệ thống thực hiện thay đổi.",
          fileBiggerThan300M: "Vui lòng tải file có dung lượng dưới 300 MB",
          fileModified: "Tệp tin không tồn tại",
          deleteVersion: "Xóa phiên bản"
        },
        formSchedule: {
          nextExecution: "Lần Chạy Tới",
          repeatUnit: "Đơn vị lặp lại",
          repeatInterval: "Khoảng Lặp",
          ends: "Kết Thúc",
          never: "Không Bao Giờ",
          occurrences: "Giới Hạn Số Lần",
          mailReport: "Báo Cáo Qua Mail",
          threatNotify: "Thông Báo Tức Thì",
          xmlReport: "Báo Cáo Dạng XML",
          minutes: "Phút",
          hours: "Giờ",
          days: "Ngày",
          weeks: "Tuần",
          months: "Tháng",
        },
        formScheduleThreatNotidy: {
          types: "Loại",
          priorities: "Mức độ",
        },
        formScheduleXmlReport: {
          types: "Loại",
          priorities: "Mức độ",
          group: "Nhóm",
        },
        download: {
          instructions: "Hướng Dẫn",
          howTo: "Hướng dẫn cài đặt CyRadar Endpoint Endpoint Security",
          step: "Bước",
          download: "Tải về",
          installer: "bộ cài CyRadar Endpoint Security",
          doubleClick:
            "Nhấp đúp vào tập tin vừa tải về, bộ cài sẽ được khởi động.",
          fillInfo: "Điền vào các thông tin cần thiết",
          serverAddress: "Địa chỉ server",
          serverAddressExplain:
            "địa chỉ IP của máy chủ CyRadar đặt tại khách hàng. Nếu không có hướng dẫn cụ thể của quản trị viên, người dùng có thể điền",
          port: "Cổng kết nối",
          portExplain:
            "cổng kết nối của máy chủ CyRadar. Nếu không có hướng dẫn cụ thể của quản trị viên, người dùng có thể điền",
          license: "Mã bản quyền",
          licenseExplain:
            "mã bản quyền dùng để xác minh và phân loại các máy trạm. Liên hệ quản trị viên để có thông tin này.",
          contact: "Thông tin liên hệ",
          contactExplain: "(tùy chọn) Thông tin liên hệ của người dùng.",
          pressInstall: "Nhấn nút <strong>Cài đặt</strong>.",
          beginToInstall:
            "Bộ cài sẽ tự động tải về các tập tin cần thiết và bắt đầu quá trình cài đặt CyRadar Endpoint Security trên máy trạm.",
          restartToComplete:
            "Khởi động lại máy tính để hoàn tất quá trình cài đặt.",
          tag: "Thẻ",
          os: "Hệ điều hành",
        },
        alert: {
          alerts: "Cảnh Báo",
          recipients: "Người Nhận",
          status: "Trạng Thái",
          waiting: "Đang Chờ",
          failed: "Lỗi",
          done: "Xong",
          nextExecutation: "Lần Chạy Tới",
          action: "Hành Động",
          newThreatNotifyTask: "Thêm Tác Vụ: Cảnh Báo Tức Thì",
          updateThreatNotifyTask: "Cập Nhật Tác Vụ: Cảnh Báo Tức Thì",
        },
        collector: {
          siem: "SIEM",
          type: "Loại",
          endpoint: "Địa chỉ",
          create: "Thêm",
          updateSIEM: "Sửa SIEM",
          header: "Header",
          endpointIsEmpty: "Hãy nhập địa chỉ",
          endpointIsInvalid: "Địa chỉ không hợp lệ",
          headerIsEmpty: "Hãy nhập header",
          headerIsDuplicate: "Header đã tồn tại",
          sendEvents: "Gửi Events",
          send: "Gửi",
          timeRange: "Khoảng Thời Gian",
          intergrationToken: "Mã tích hợp",
          key: "Mã",
          name: "Tên",
          allowedIP: "IP cho phép",
          addIntergrationToken: "Thêm mã tích hợp",
          updateIntergrationToken: "Cập nhật mã tích hợp",
        },
        server: {
          enterName: "Nhập tên",
          empty: "Không có giá trị",
          detailInfor: "Thông tin chi tiết",
          updateHistory: "Lịch sử cập nhật",
          edrServerChild: "Máy chủ EDR server con",
          serial: "STT",
          name: "Tên",
          ipAddress: "Địa chỉ IP",
          createdAt: "Thời điểm tạo",
          lastConnection: "Kết nối lần cuối",
          status: "Trạng thái",
          enable: "Kích hoạt",
          disable: "Huỷ kích hoạt",
          enabled: "Đã kích hoạt",
          disabled: "Không kích hoạt",
          statistics: "Thống kê",
          viewInfor: "Xem thông tin",
          downloadActivationFile: "Tải tệp kích hoạt",
          createServer: "Tạo mới EDR Server Mới",
          updateRepositories: "Cập nhật kho lưu trữ",
          updateServer: "Cập nhật EDR Server",
          update: "Cập nhật",
          basic: "Cơ bản",
          quotas: "Cài đặt thông số",
          repositories: "Kho lưu trữ",
          fingerprint: "Mã định danh",
          email: "Email",
          phoneNumber: "Số điện thoại",
          address: "Địa chỉ",
          company: "Công ty",
          description: "Mô tả",
          numberOfAgents: "Số lượng agent",
          numberOfEDRChildServers: "Số lượng EDR server con",
          expiredAt: "Ngày hết hạn",
          numberOfEDRChildLevels: "Số cấp EDR con",
          total: "Tổng:",
          tagsToBeUpdated: "Sản phẩm cập nhật",
          default: "Mặc định",
          setDefault: "Đặt làm mặc định",
          delete: "Xoá",
          invalidFormat: "Sai định dạng",
          cannotBeLeftBlank: "Trường này không được để trống",
          greaterOrEqualZero: "Số lượng phải lớn hơn hoặc bằng 0",
          agentLimit: "Số lượng agent tối đa",
          serverLimit: "Số lượng server tối đa",
          agentCount: "Số máy trạm được bảo vệ",
          serverCount: "Số edr server con quản lí",
          lowPriorityThreats: "Mối đe dọa thấp đã xử lý",
          mediumPriorityThreats: "Mối đe dọa trung bình đã xử lý",
          highPriorityThreats: "Mối đe dọa cao đã xử lý",
          criticalThreats: "Mối đe dọa nghiêm trọng đã xử lý",
          updatedAt: "Cập nhật lần cuối",
          tags: "Sản phẩm",
          type: "Loại",
          numberOfFile: "Số file",
          serverName: "Tên server",
          invalidNameFormat: "Tên sai định dạng",
          invalidEmailFormat: "Email sai định dạng",
          invalidPhoneNumberFormat: "Số điện thoại sai định dạng",
          addressPlaceholder:
            "Tầng 9, Toà nhà FPT, 10 Phạm Văn Bạch, Quận Cầu Giấy, Hà Nội",
          companyPlaceholder: "Công ty cổ phần an toàn thông tin CyRadar",
          unlimit: "Không giới hạn",
          serverValidLength: "Tên phải có chiều dài từ 3 đến 256 kí tự",
          serverValidFormat:
            "Tên không bao gồm dấu cách và chỉ có thể bao gồm các kí tự có kiểu chữ, số nguyên, các dấu . hoặc _",
          fingerprintValidFormat:
            "Mã định danh phải có dạng XXXXX-XXXXX-XXXXX-XXXXX-XXXXX",
          emailValidFormat: "Email không đúng định dạng",
          phoneValidFormat: "Số điện thoại không đúng định dạng",
          agentLimitPlaceholder: "Điền một số nguyên rồi chọn giá trị",
          agentLimitNotFound: "Phải là số nguyên lớn hơn 0",
          limitValidFormat: "Số lượng phải lớn hơn hoặc bằng 0",
        },
        settings: {
          copyrights: "Bản quyền",
          scheduleUpdate: "Lịch cập nhật",
          emailServer: "Email của server",
          telegramBots: "Liện hệ telegram",
          licenseInfor: "Thông tin giấy phép",
          product: "Sản phẩm",
          copyright: "Bản quyền",
          licenseCode: "Mã giấy phép",
          expirationDate: "Ngày hết hạn",
          maxAgent: "Agent tối đa",
          maxEDRServer: "EDR server tối đa",
          maxLevelEDRServer: "Cấp tối đa EDR server",
          proxyServer: "Proxy",
          serverStatus: "Trạng thái server",
          periodTime: "Khoảng thời gian",
          updateLicense: "Cập nhật giấy phép",
          updateLicenseText1: "Để sử dụng một giấy phép khác, vui lòng chọn ",
          updateLicenseText2: "Đổi giấy phép ",
          updateLicenseText3: "ở bên dưới.",
          updateLicenseText4:
            "Trong trường hợp bạn không có giấy phép, vui lòng liên hệ hotline (+84) 24 7300 6066 hoặc ",
          updateLicenseText5: "contact@cyradar.com.",
          updateLicenseOnline: "Cập nhật giấy phép trực tuyến",
          updateLicenseOffline: "Cập nhật giấy phép ngoại tuyến",
          checkConnection: "Kiểm tra kết nối",
          serverUpdate: "Máy chủ cập nhật",
          licenseInfor: "Thông tin giấy phép",
          checkConnectionToServerUpdate:
            "Kiểm tra kết nối đến máy chủ cập nhật",
          minutes: "phút",
          hours: "giờ",
          updateServer: "Cập nhật máy chủ",
          updateProxy: "Cập nhật máy chủ uỷ quyền",
          updatePeriod: "Cập nhật khoảng thời gian",
          timezone: "Múi giờ",
          database: "Cơ sở dữ liệu",
          repeat: "Lặp lại",
          schedule: "Lịch",
          startOn: "Bắt đầu lúc",
          repeatOn: "Lặp lại vào",
          engine: "Engine",
          beats: "Theo giờ",
          daily: "Hằng ngày",
          weekly: "Hằng tuần",
          none: "Không",
          installer: "Bản cài đặt",
          enabled: "Đã kích hoạt",
          disabled: "Không kích hoạt",
          check: "Kiểm tra",
          success: "Thành công",
          fail: "Thất bại",
          information: "Thông tin",
          cannotConect: "Không thể kết nối đến server",
          online: "Trực tuyến",
          offline: "Ngoại tuyến",
          unknown: "Không xác định",
          empty: "Không có giá trị",
          unlimit: "Không giới hạn",
          unit: "Đơn vị thời gian",
          interval: "Khoảng thời gian",
          cannotBeLeftBlank: "Trường này không được để trống",
          fingerprintValidFormat:
            "Mã định danh phải có dạng XXXXX-XXXXX-XXXXX-XXXXX-XXXXX",
          license: "Mã định danh",
        },
      },
    },
    en: {
      teible: {
        showing: "Showing",
        total: "of {count} records",
        last: "the last record",
        empty: "No records",
        filter: "Filter records",
      },
      route: {
        overview: "Overview",
        threat: "Threat",
        agent: "Agent",
        management: "Management",
        policy: "Policy",
        report: "Report",
        schedule: "Schedule",
        config: "Config",
        intergration: "Intergration",
        info: "Info",
        group: "Group",
        license: "License",
        user: "User",
        update: "Update",
        search: "Search...",
        notFound: "NOT FOUND"

      },
      global: {
        detail: "Detail",
        action: "Action",
        edit: "Edit",
        update: "Update",
        delete: "Delete",
        submit: "Submit",
        close: "Close",
        add: "Add",
        send: "Send",
        cancel: "Cancel",
        download: "Download",
        all: "All",
        quickView: "Quick View",
        confirmDelete: "Are you sure you want to delete this?",
        next: "Next",
        upload: "Upload",
        uploadAgain: "Upload again",
        complete: "Complete",
        active: "Active",
        check: "Check",
        checkAgain: "Check again",
        back: "Back",
        finish: "Finish",
        downloadDown: "Download",
        reset: "Reset",
      },
      components: {
        login: {
          downloadCyEDR: "Download CyEDR",
          downloadCyES: "Download CyRadar Endpoint Security",
        },
        overview: {
          protectedUsers: "Protected Users",
          detectedThreats: "Detected & Isolated Threats",
          highPriorityThreats: "High Priority Threats",
          criticalThreats: "Critical Threats",
          recentThreatEvents: "Recent Threat Events",
          topInfectedClients: "Top Infected Clients",
          topInfectedGroups: "Top Infected Groups",
          category: "Category",
          clients: "Clients",
          groups: "Groups",
          total: "Total",
          systemDiagram: "System diagram",
          totalGroup: "Total group",
        },
        threats: {
          lowPriorityThreats: "Low Priority Threats",
          mediumPriorityThreats: "Medium Priority Threats",
          highPriorityThreats: "High Priority Threats",
          criticalThreats: "Critical Threats",
          threatEvents: "Threat Events",
          group: "Group",
          processName: "Process Name",
          priority: "Priority",
          category: "Category",
          malwareName: "Malware Name",
          time: "Time",
          user: "User",
          computerName: "Computer name",
          action: "Action",
          sample: "Sample",
          activityDetail: "Activity Detail",
          processTree: "Process Tree",
          processInfo: "Process Info",
          name: "Name",
          path: "Path",
          pid: "PID",
          parentPID: "Parent PID",
        },
        agents: {
          agents: "Agents",
          agentDetail: "Agent Detail",
          group: "Group",
          command: "Command",
          commandType: "Command Type",
          path: "Path",
          pendingCommands: "Pending Commands",
          payload: "Payload",
          time: "Time",
          status: "Status",
          computerName: "Computer name",
          ip: "Local IP",
          operatingSystem: "Operating system",
          agentVersion: "Agent Version",
          vulnerabilities: "Vulnerabilities",
          installTime: "Install Time",
          lastConnection: "Last connection",
          localIP: "Local IP",
          action: "Action",
          removed: "Removed",
          agentIP: "Connect IP",
          mac: "Mac",
          macNetwork: "Mac Network",
          lastUpdate: "Window Update",
          userName: "Username",
          enableFirewall: "Enable Firewall",
          autoProtect: "Auto Protect",
          message: "Message",
          contact: "Contact",
          active: "Active",
          disabled: "Non-Active",
          disabledDesc:
            "Showing agents which had no connection to the server in the last {days} days.",
          agentSetting: "Agent Setting",
          activeTimeout: "Active Timeout",
          days: "Days",
          timeoutDesc:
            "Agents which had no connection to the server in this timeout will be moved to the non-active section.",
          timeoutEnableDesc:
            "To enable this feature, set the timeout value first.",
          timeoutDisableDesc: "To disable this feature, set the timeout to 0.",
          securityStatus: "Security status",
          childGroups: "Child groups",
          threats: "Threats",
          copyrights: "Copyrights",
          version: "Version",
          threatCount: "Threat count",
          description: "Description",
          viewInformation: "View information",
          delete: "Delete",
          update: "Update",
          Command: "Command",
          threat: "Threat",
          license: "License",
          serverInfor: "Server information",
          commandAllAgents: "Command all agents",
          commandGroupAgents: "Command group",
          currentLicense: "Current license",
          destLicense: "Dest license",
        },
        policies: {
          add: "Add",
          policies: "Policies",
          whitelist: "Whitelist",
          blacklist: "Blacklist",
          scheduleScan: "Schedule Scan",
          restriction: "Password-Protected Uninstallation",
          blacklistHelp:
            "Block client from connecting to specific destination.",
          restrictionHelp:
            "Restrict user from doing certain actions (e.g. uninstall).<br>Use password provided by admin to unlock.",
          unknownPC: "Unknown PC",
          name: "Name",
          type: "Type",
          computerName: "Computer Name",
          audience: "Audience",
          action: "Action",
          description: "Description",
          policyType: "Policy Type",
          groups: "Groups",
          agents: "Agents",
          general: "General",
          specific: "Specific",
          everyone: "Everyone",
          accessControlList: "Access Control List",
          ip: "IP",
          port: "Port",
          password: "Password",
          newPolicy: "New Policy",
          updatePolicy: "Update Policy",
          date: "Date",
          time: "Time",
          updateAgent: "Update Agent",
          auto: "Auto",
          manual: "Manual",
          schedule: "Schedule",
          updateType: "Update Type",
          updateDatabase: "Update Database",
          scheduleUpdate: "Schedule Update",
          once: "Once",
          daily: "Daily",
          weekly: "Weekly",
          monthly: "Monthly",
          interval: "Interval",
          updatedAt: "Updated At",
        },
        report: {
          reportExport: "Report Export",
          group: "Group",
          timeRange: "Time Range",
          reportType: "Report Type",
          users: "Users",
          maliciousHosts: "Malicious Hosts",
          priorities: "Priorities",
          categories: "Categories",
          preview: "Preview",
          download: "Download",
          confirmation: "Confirmation",
          organizationID: "Organization ID",
          organizationName: "Organization Name",
          organizationAddress: "Organization Address",
          email: "Email",
          telephone: "Telephone",
          fax: "Fax",
          website: "Website",
          reportEndpoint: "Report Endpoint",
          confirmSubmit: "Confirm & Submit",
          pdfReport: "PDF Report",
          noSupportPDF:
            "This browser does not support PDFs. Please download the PDF to view it:",
          downloadPDF: "Download PDF",
          xmlReport: "XML Report",
          copyToClipboard: "Copy to clipboard",
          name: "Name",
          schedulesReport: "Report Schedules",
          waiting: "Waiting",
          failed: "Failed",
          done: "Done",
          newScheduleTask: "New Schedule Task",
          updateMailReportTask: "Update Mail Report Task",
          updateXMLReportTask: "Update XML Report Task",
          task: "Task",
          status: "Status",
          nextExecutation: "Next executation",
          repeating: "Repeating",
          endding: "Endding",
          action: "Action",
        },
        schedule: {
          schedules: "Schedules",
          waiting: "Waiting",
          failed: "Failed",
          done: "Done",
          newScheduleTask: "New Schedule Task",
          updateMailReportTask: "Update Mail Report Task",
          updateThreatNotifyTask: "Update Threat Notify Task",
          updateXMLReportTask: "Update XML Report Task",
          task: "Task",
          status: "Status",
          nextExecutation: "Next executation",
          repeating: "Repeating",
          endding: "Endding",
          action: "Action",
        },
        configuration: {
          organizationInfo: "Organization Info",
          agentsGroup: "Agents Group",
          license: "License",
          dashboardUser: "Dashboard User",
          offlineUpdate: "Offline Update",
        },
        configurationInfo: {
          info: "Info",
          name: "Name",
          group: "Group",
          organizationInfo: "Organization Info",
          endpoint: "Endpoint",
          organizationID: "Organization ID",
          organizationName: "Organization Name",
          organizationAddress: "Organization Address",
          email: "Email",
          telephone: "Telephone",
          fax: "Fax",
          website: "Website",
          reportEndpoint: "Report Endpoint",
        },
        configurationGroup: {
          groups: "Groups",
          name: "Name",
          groupKey: "Group Key",
          licenseKey: "License Key",
          createLicense: "Create a new license key for this group",
          netmask: "Netmask",
          subnets: "Subnets",
          agents: "Agents",
          description: "Description",
          groupName: "Group Name",
          childGroups: "Child Groups",
          count: "Count",
          agentCount: "Agent Count",
          action: "Action",
          createNewGroup: "Create New Group",
          editGroup: "Edit Group",
          serial: "No",
          parentGroup: "Parent group",
          theadCount: "Thead count",
          groupChildCount: "Group child count",
          licenseCount: "License count",
          update: "Update",
          delete: "Delete",
          command: "Command",
          viewInformation: "View information",
        },
        configurationLicense: {
          licenses: "Licenses",
          random: "Random",
          licenseKey: "License Key",
          agentGroups: "Agent Groups",
          limit: "Limit",
          countLimit: "Count/Limit",
          limited: "Limited",
          unlimited: "Unlimited",
          agents: "Agents",
        },
        user: {
          dashboardUsers: "Dashboard Users",
          userName: "Username",
          name: "Name",
          type: "Type",
          group: "Group",
          oldPassword: "Old Password",
          password: "Password",
          confirmPassword: "Confirm Password",
          action: "Action",
          createNewUser: "Create New User",
          updateUser: "Update User",
        },
        configurationUpdate: {
          viewRepo: "View repositories",
          agent: "Agent",
          database: "Database",
          offlineUpdate: "Offline Update",
          agentUpdateFile: "Agent Update File",
          dashboardUpdateFile: "Database Update File",
          chooseAFile: "Choose a file...",
          noFileChosen: "No file chosen",
          update: "Update",
          version: "Version",
          tag: "Tag",
          os: "OS",
          repositories: "Repositories",
          serial: "No",
          name: "Name",
          createdAt: "Created at",
          creator: "Creator",
          tags: "Products",
          fileNumber: "File number",
          status: "Status",
          type: "Type",
          description: "Description",
          updatedAt: "Updated At",
          active: "Activated",
          inactive: "Not activated",
          invalidFormat: "Invalid format",
          invalidName: "Invalid name",
          update: "Update",
          enable: "Enable",
          disable: "Disable",
          setDefault: "Set default",
          default: "Default",
          updateTag: "Update product",
          createTag: "Create product",
          updateOS: "Update os",
          createOS: "Create os",
          fileName: "File name",
          size: "Size",
          error: "Error",
          ready: "Ready",
          viewInfor: "View infor",
          deleteFile: "Delete file",
          checkMD5: "Check MD5",
          inforFileUpdate: "Infor file update",
          database: "Database",
          baseEngine: "BsEngine",
          advanceEngine: "AvEngine",
          installer: "Installer",
          createRepo: "Create repositories",
          confirmDeleteFile: "Confirm delete file",
          warning: "Attention! This action cannot be undone",
          uploadFile: "Upload file",
          downloadFile: "Download file",
          initializing: "Initializing",
          canceled: "Canceled",
          createVersion: "Create version",
          basic: "Basic",
          updateVersion: "Update version",
          currentVersion: "Current version",
          supportedOSList: "Supported OS List",
          attachFile: "Attach File",
          cannotBeLeftBlank: "Cannot be left blank",
          invalidFile: "Unsupported format",
          versionInfor: "Version infor",
          confirmDeactivate: "Confirm deactivate",
          confirmSetDefault: "Confirm set as default",
          tagName: "Tag name",
          tagWarning: "Attention! This action may affect agent updates",
          noVersion: "No version has been created yet",
          fileUploadError: "File upload error",
          enterName: "Enter name",
          enabled: "Enabled",
          disabled: "Disabled",
          uploading: "Uploading",
          createOfflineFile: "Create offline file",
          confirmCreateVersionOffline:
            "Confirm creation of offline version file",
          createVersionOfflineWarning:
            "Are you sure want to create file this item?",
          createNew: "Create new",
          uploadFileOffline: "Upload file offline",
          chooseFile: "Choose file...",
          wrongFileType:
            "Inappropriate file format. Please download the .zip file",
          uploadFailed: "Upload failed",
          uploadSuccessful:
            "File upload successful. Please wait a moment for the system to make changes.",
          product: "Product",
          deleteOS: "Delete OS",
          deleteOSConfirm: "Delete OS confirm",
          chooseTags: "Choose products",
          versionValidLength:
            "The version must have a length ranging from 3 to 256 characters",
          versionValidFormat:
            "The version cannot contain spaces and can only include alphanumeric characters, dots (.), or underscores (_)",
          versionValidDuplication: "This version already exists",
          fileValidFormat: "The format is not supported",
          uploadError: "Error uploading file",
          nameValidLength:
            "Name must have a length ranging from 3 to 256 characters",
          nameValidFormat:
            "Name must be alphanumeric, allowing only dots ., hyphens -, and underscores _, without spaces",
          fileUploadOfflineValidFormat:
            "The format is not supported. Please, upload zip file.",
          fileUploadOfflineValidFormat:
            "The format is not supported. Please, upload zip file.",
          fileUploadOfflineSuccess:
            "Download file successfully. Please wait a moment for the system to make the changes.",
          fileBiggerThan300M:
            "Please download files with a capacity of less than 300 MB",
          fileModified: "The file does not exist",
          deleteVersion: "Delete version"
        },
        formSchedule: {
          nextExecution: "Next Excution",
          repeatUnit: "Repeat Unit",
          repeatInterval: "Repeat Interval",
          ends: "Ends",
          never: "Never",
          occurrences: "Occurrences",
          mailReport: "Mail Report",
          threatNotify: "Threat Notify",
          xmlReport: "XML Report",
          minutes: "Minute",
          hours: "Hour",
          days: "Day",
          weeks: "Week",
          months: "Month",
        },
        formScheduleThreatNotidy: {
          types: "Types",
          priorities: "Priorities",
        },
        formScheduleXmlReport: {
          types: "Types",
          priorities: "Priorities",
          group: "Group",
        },
        download: {
          instructions: "Instructions",
          howTo: "How to install CyRadar Endpoint Security",
          step: "Step",
          download: "Download",
          installer: "CyRadar Endpoint Security installer",
          doubleClick:
            "Double click the recently downloaded file, the installer will start.",
          fillInfo: "Fill the infomation as required",
          serverAddress: "Server address",
          serverAddressExplain:
            "the address of the local CyRadar server. If there isn't any instructions from administrator, you can use",
          port: "Server port",
          portExplain:
            "the port of the local CyRadar server. If there isn't any instructions from administrator, you can use",
          license: "License",
          licenseExplain:
            "the license code used to verify and classify agent. Contact your administrator for this.",
          contact: "Contact",
          contactExplain: "(optional) The user's contact information.",
          pressInstall: "Press the <strong>Install</strong> button.",
          beginToInstall:
            "The installer will auto download required files and begin to install CyRadar Endpoint Security on the computer.",
          restartToComplete:
            "Restart the computer to complete the installation.",
          tag: "Tag",
          os: "Operating system",
        },
        alert: {
          alerts: "Alerts",
          recipients: "Recipients",
          status: "Status",
          waiting: "Waiting",
          failed: "Failed",
          action: "Action",
          nextExecutation: "Next executation",
          done: "Done",
          newThreatNotifyTask: "New Threat Notify Task",
          updateThreatNotifyTask: "Update Threat Notify Task",
        },
        collector: {
          siem: "SIEM",
          type: "Type",
          endpoint: "Endpoint",
          create: "Create",
          updateSIEM: "Update SIEM",
          header: "Header",
          endpointIsEmpty: "The endpoint is empty",
          endpointIsInvalid: "The endpoint is invalid",
          headerIsEmpty: "The header is empty",
          headerIsDuplicate: "The header is duplicate",
          sendEvents: "Send Events",
          send: "Send",
          timeRange: "Time Range",
          intergrationToken: "Intergration Token",
          key: "Key",
          name: "Name",
          allowedIP: "Allowed IP",
          addIntergrationToken: "Add Intergration Token",
          updateIntergrationToken: "Update Intergration Token",
        },
        server: {
          enterName: "Enter name",
          updateRepositories: "Update repositories",
          empty: "N/A",
          detailInfor: "Detail information",
          updateHistory: "Updating history",
          edrServerChild: "EDR server child",
          serial: "No",
          name: "Name",
          ipAddress: "IP address",
          createdAt: "Created at",
          lastConnection: "Last connection",
          status: "Status",
          enable: "Enable",
          disable: "Disable",
          enabled: "Enabled",
          disabled: "Disabled",
          statistics: "Statistics",
          viewInfor: "View server infor",
          downloadActivationFile: "Download activation file",
          createServer: "Create new EDR Server",
          basic: "Basic",
          quotas: "Quotas",
          repositories: "Repositories",
          fingerprint: "Identifier",
          email: "Email",
          phoneNumber: "Phone number",
          address: "Address",
          company: "Company",
          description: "Description",
          numberOfAgents: "Number of agents",
          numberOfEDRChildServers: "Number of EDR child servers",
          expiredAt: "Expiration date",
          numberOfEDRChildLevels: "Number of EDR child levels",
          total: "Total:",
          tagsToBeUpdated: "Products to be updated",
          default: "Default",
          setDefault: "Set default",
          delete: "Delete",
          invalidFormat: "Invalid format",
          cannotBeLeftBlank: "Cannot be left blank",
          greaterOrEqualZero: "Quantity must be greater than or equal to 0",
          updateServer: "Update EDR Server",
          update: "Update",
          agentLimit: "Agent limit",
          serverLimit: "Server limit",
          agentCount: "The number of agents protected",
          serverCount: "The number of managed EDR servers",
          lowPriorityThreats: "Low Priority Threats",
          mediumPriorityThreats: "Medium Priority Threats",
          highPriorityThreats: "High Priority Threats",
          criticalThreats: "Critical Threats",
          updatedAt: "Updated at",
          tags: "Products",
          type: "Type",
          numberOfFile: "File",
          serverName: "Server name",
          invalidNameFormat: "Invalid name format",
          invalidEmailFormat: "Invalid email format",
          invalidPhoneNumberFormat: "Invalid phone number format",
          addressPlaceholder:
            "9th Floor, FPT Tower, 10 Pham Van Bach street, Cau Giay District, Ha Noi",
          companyPlaceholder:
            "CyRadar Information Security Joint Stock Company",
          unlimit: "Unlimit",
          serverValidLength:
            "Name must have a length ranging from 3 to 256 characters",
          serverValidFormat:
            "Name cannot contain spaces and can only include alphanumeric characters, dots (.), or underscores (_)",
          fingerprintValidFormat:
            "Fingerprint must be in the form XXXXX-XXX-XXXXX-XXXXX-XXXXX",
          emailValidFormat: "Email invalidate",
          phoneValidFormat: "Phone number invalidate",
          agentLimitPlaceholder: "Fill in an integer and then select the value",
          agentLimitNotFound: "Must be an integer greater than 0",
          limitValidFormat: "The quantity must be greater than or equal to 0",
        },
        settings: {
          copyrights: "Copyrights",
          scheduleUpdate: "Schedule update",
          emailServer: "Email server",
          telegramBots: "Telegram bots",
          licenseInfor: "License information",
          product: "Product",
          copyright: "Copyright",
          licenseCode: "License code",
          expirationDate: "Expiration date",
          maxAgent: "Max agent",
          maxEDRServer: "Max EDR server",
          maxLevelEDRServer: "Max level EDR server",
          proxyServer: "Proxy server",
          serverStatus: "Server status",
          periodTime: "Period time",
          updateLicense: "Update license",
          updateLicenseText1: "To use another license, please select ",
          updateLicenseText2: "Change license ",
          updateLicenseText3: "below.",
          updateLicenseText4:
            "In case you do not have a license, please contact hotline (+84) 24 7300 6066 or ",
          updateLicenseText5: "contact@cyradar.com.",
          updateLicenseOnline: "Update license online",
          updateLicenseOffline: "Update license offline",
          checkConnection: "Check connection",
          serverUpdate: "Server update",
          licenseInfor: "License infor",
          checkConnectionToServerUpdate: "Check connection to server update",
          minutes: "minutes",
          hours: "hours",
          updateServer: "Update server",
          updateProxy: "Update proxy",
          updatePeriod: "Update period",
          timezone: "Timezone",
          database: "Database",
          database: "Database",
          repeat: "Repeat",
          schedule: "Schedule",
          startOn: "Start on",
          repeatOn: "Repeat on",
          engine: "Engine",
          beats: "Beats",
          daily: "Daily",
          weekly: "Weekly",
          none: "None",
          installer: "Installer",
          enabled: "Enabled",
          disabled: "Disabled",
          check: "Check",
          success: "Success",
          fail: "Fail",
          information: "Information",
          cannotConect: "Cannot conect to server",
          online: "Online",
          offline: "Offline",
          unknown: "Unknown",
          empty: "N/A",
          unlimit: "Unlimit",
          unit: "Unit",
          interval: "Interval",
          cannotBeLeftBlank: "Cannot be left blank",
          fingerprintValidFormat:
            "Fingerprint must be in the form XXXXX-XXX-XXXXX-XXXXX-XXXXX",
          license: "License",
        },
      },
    },
  },
};
